<div class="row my-5">
	<ul
		class="nav border-bottom justify-content-between justify-content-lg-start px-lg-5"
	>
		<li class="nav-item" *ngFor="let tab of tabs">
			<a
				class="nav-link theme-main-color"
				(click)="scrollTop()"
				[routerLink]="[tab.path]"
				[ngClass]="{
					'active fw-bold border-0 border-bottom border-3 border-custom-theme':
						isRouterActive(tab.parentPath)
				}"
			>
				<i class="bi" [ngClass]="tab.icon" aria-hidden="true"></i>
				<span> {{ tab.name }}</span></a
			>
		</li>
	</ul>
</div>
<div class="row px-lg-5">
	<div class="col-12">
		<app-change-password
			class="my-4"
			*ngIf="pageSelector.isActive('/espace-perso/securite', true)"
		>
		</app-change-password>
	</div>
	<div class="col-12">
		<app-user-infos
			class="my-4"
			*ngIf="pageSelector.isActive('/espace-perso/profil', true)"
		>
		</app-user-infos>
	</div>
</div>
